<template>
    <div id="app">
        <main-navbar :color-on-scroll="27" />
        <div class="wp">
            <router-view />
        </div>
        <main-footer />
    </div>
</template>

<script>
    import {CURRENT_STORE_QUERY} from '@/services/graphql/store';
    import {createNamespacedHelpers} from 'vuex';
    const {mapMutations} = createNamespacedHelpers('Store');
    import MainNavbar from './MainNavbar';
    import MainFooter from './MainFooter';

    export default {
        name: "Container",
        components: {
            MainNavbar,
            MainFooter
        },
        methods: {
            ...mapMutations(['setInfo']),
            async getStoreInfo() {
                try {
                    const q = await this.$apollo.query({
                        query: CURRENT_STORE_QUERY,
                        fetchPolicy: "network-only"
                    });
                    this.setInfo(q.data.storeNow);
                } catch (err) {
                    console.error(err);
                }
            },
        },
        created() {
            this.getStoreInfo();
        }
    }
</script>

<style scoped>
    .wp {
        min-height: calc(100vh - 78px);
    }
</style>